import { CallEffect } from 'redux-saga/effects';

/**
 * @deprecated
 */
export function* seq(calls: CallEffect[]): any {
  const results = [];
  for (const callInstance of calls) {
    const result = yield callInstance;
    results.push(result);
  }
  return results;
}
export async function sequentialAsyncMap<T>(callbacks: (() => Promise<T>)[]): Promise<T[]> {
  const results = [];
  for (const cb of callbacks) {
    const result = await cb();
    results.push(result);
  }
  return results;
}
